var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.524 3.583c-1.113.493-2.31.826-3.567.977a6.226 6.226 0 002.731-3.437 12.4 12.4 0 01-3.944 1.506A6.213 6.213 0 0015.16 8.296a17.639 17.639 0 01-12.803-6.49 6.208 6.208 0 00-.84 3.122 6.213 6.213 0 002.763 5.17 6.196 6.196 0 01-2.813-.777v.08a6.214 6.214 0 004.982 6.091 6.257 6.257 0 01-2.805.107 6.215 6.215 0 005.803 4.312 12.464 12.464 0 01-7.715 2.66c-.495 0-.99-.03-1.483-.087a17.567 17.567 0 009.52 2.79c11.427 0 17.674-9.463 17.674-17.671 0-.267-.007-.536-.019-.803a12.625 12.625 0 003.097-3.213l.003-.004z",
    fill: "#343434"
  })));
}
export default SvgTwitter;